/** A Jira Cloud site's host. A copy of
 * packages/integrations/jira/shared/src/site.ts. Lowercase, one
 * label, then `.atlassian.net`. A `site` item's id is this host.
 *
 * Nothing else gets in: P0 builds the URL it calls for the site's
 * cloud ID from the host. */
const SITE_HOST_PATTERN = /^[a-z0-9][a-z0-9-]*\.atlassian\.net$/;

/** What to enter when {@link isSiteHost} refuses a value. The message doesn't
 * repeat the value: the install framework's error for a refused field does
 * carry it, to whoever sent it and to the log. */
export const INVALID_SITE_HOST =
  "Enter the site's host in lowercase, as <name>.atlassian.net, such as acme.atlassian.net. Leave out https:// and anything after the host.";

/** Whether `host` is a Jira Cloud site's host, in the one spelling P0 stores.
 * It's checked as it stands: an item's id isn't trimmed. */
export const isSiteHost = (host: unknown): host is string =>
  typeof host === "string" && SITE_HOST_PATTERN.test(host);
